import { mainApi } from "services/main";
import { TaxArea } from "models/schemas";
import {
  GetTeamByIdRequest,
  GetTeamByIdResponse,
  ListTaxAreaRequest,
  ListTaxAreaResponse,
  CreateTaxAreaResponse,
  UpdateTaxAreaResponse,
} from "./definitions";
import { CreateTaxAreaInput } from "components/create-taxarea-form";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getTeamById: builder.query<GetTeamByIdResponse, GetTeamByIdRequest>({
      query: (request: GetTeamByIdRequest) => ({
        url: `team/${request.teamId}`,
        params: {
          teamName: request.teamName,
        },
      }),
    }),
    listTaxAreaByTeam: builder.query<ListTaxAreaResponse, ListTaxAreaRequest>({
      query: (request: ListTaxAreaRequest) => ({
        url: `taxAreas/${request.teamName}`,
      }),
      providesTags: ["TaxArea"],
    }),
    createTaxArea: builder.mutation<CreateTaxAreaResponse, CreateTaxAreaInput>({
      query: (request?: CreateTaxAreaInput) => ({
        url: "taxArea",
        body: request,
        method: "POST",
      }),
      invalidatesTags: ["TaxArea"],
    }),
    updateTaxArea: builder.mutation<UpdateTaxAreaResponse, TaxArea>({
      query: (request?: TaxArea) => ({
        url: `taxArea/${request?.taxAreaId}`,
        body: request,
        method: "PUT",
      }),
      invalidatesTags: ["TaxArea"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTeamByIdQuery,
  useListTaxAreaByTeamQuery,
  useCreateTaxAreaMutation,
  useUpdateTaxAreaMutation,
} = extendedApi;
